// todo move this file to module
export const LoginOptions = {
    '0': 'شماره تلفن یا ایمیل و رمز',
    '1': 'شماره تلفن',
}
